import { getHrefUrl } from './../url/get-href-url';

import type { LinkOldOrNew } from './types';

export const getLinkHrefUrl = (link: LinkOldOrNew, baseUrl?: string): string | undefined =>
  typeof link.url === 'string'
    ? getHrefUrl(link.url, baseUrl)
    : typeof link.anchor === 'string'
    ? `#viewer-${link.anchor}`
    : undefined;
